import { CatalogDTO } from '@/common/dto/catalog';
import {
  IBenefit,
  IBenefitOptin,
  IBenefitProduct,
  IMenhirBenefit,
  IMenhirBenefitDetail,
  IMenhirBenefitOptin,
  IMenhirBenefitProduct,
} from '@/common/integrations/menhir/employee/benefits/benefits.types';

export const transformBenefitCategory = (
  category: IMenhirBenefit
): IBenefit => ({
  id: category.id,
  slug: category.slug,
  name: category.name,
  description: category.description,
  icon_url: category.icon_url,
  children: category.children?.map(transformBenefitCategory),
  parent_id: category.parent_id,
  products: category.products.map(transformBenefitCategoryProduct),
  exemptions: category.exemptions
    ? {
        socialSecurity: category.exemptions?.social_security,
        valueAddedTax: category.exemptions?.value_added_tax,
      }
    : undefined,
  usage: category.usage
    ? {
        available: category.usage.available,
        limit: category.usage.limit,
        renewalDate: category.usage.renewal_date,
        increasableLimit: category.usage.increasable_limit,
        startOn: category.usage.start_on,
        endsOn: category.usage.ends_on,
        carryover: category.usage.carryover,
      }
    : undefined,
  limits: category.limits,
});

export const transformBenefitCategoryProduct = (
  product: IMenhirBenefitProduct
): IBenefitProduct => ({
  id: product.id,
  files: product.files,
  slug: product.slug,
  type: product.type,
  rules: CatalogDTO.transformProductRules(product.rules),
  provider: product.provider
    ? CatalogDTO.transformProductProvider(product.provider)
    : undefined,
  status: product.status,
  vatReimbursementEnabled: product.vat_reimbursement_enabled,
  allowedFamilyMemberTypes: product.allowed_family_member_types,
  supportFilesEnabled: product.support_files_enabled,
});

export const transformBenefitCategoryDetail = (
  category: IMenhirBenefitDetail
) => ({
  ...transformBenefitCategory(category),
  products: category.products.map(transformBenefitCategoryProduct),
});

export const transformBenefitCategoryList = (
  categories: IMenhirBenefit[]
): IBenefit[] => categories.map(transformBenefitCategory);

export const transformBenefitOptin = (
  optin: IMenhirBenefitOptin
): IBenefitOptin => ({
  id: optin.id,
  amount: optin.attributed_amount,
  allocatedAmount: optin.allocated_amount,
  dueDate: optin.due_date,
  editable: optin.editable,
  instant: optin.instant,
});
